var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Function(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 11H15a4 4 0 00-4 4v46a4 4 0 004 4h46a4 4 0 004-4V15a4 4 0 00-4-4zm0 50H15V15h46v46zM36 40H26v-4h10V26h4v10h10v4H40v10h-4V40z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Function.b277361b.svg";
export { SvgJ2Function as ReactComponent };